module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAHNJREFUWEftl7sNgEAMQ+2Z6KjYAcY8dqCjYadQcXwkysgpnAFi58k6+QjxUKwPG6hFIGYcAIbUXBA7G8ZL40VAbiD18p/ltTJgAiZgAvKHSG7AGTABEyhBIBZMmUbYsD33fytZZIr3Hrje3wF3QndCEzgBikkaITWN084AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhedie.png
// module id = PxGs
// module chunks = 16